import React from 'react';

export default function CutsResultsHeader({
  selectedPrimal,
  searchTerm,
  resultCount,
  cookingMethods,
  cookingMethodFilter,
  setCookingMethodFilter,
  onClear
}) {
  const heading = selectedPrimal ? selectedPrimal.name : searchTerm;

  return (
    <section className="section cuts-results-header">
      <div className="container">
        <div className="cuts-results-header__top">
          <div>
            {!selectedPrimal && (
              <span className="cuts-results-header__eyebrow">Search Results</span>
            )}
            <h2 className="cuts-results-header__title">{heading}</h2>
          </div>
          <div className="cuts-results-header__top-right">
            <span className="cuts-results-header__count">
              {resultCount} Result{resultCount === 1 ? '' : 's'}
            </span>
            <button
              type="button"
              className="cuts-results-header__clear"
              onClick={onClear}
            >
              <span className="cuts-results-header__clear-icon" aria-hidden="true">
                &times;
              </span>
              Clear filters
            </button>
          </div>
        </div>

        {selectedPrimal && selectedPrimal.description && (
          <p className="cuts-results-header__description">
            {selectedPrimal.description}
          </p>
        )}

        <div className="cuts-results-header__meta">
          {selectedPrimal && selectedPrimal.butchers_note ? (
            <div className="cuts-results-header__note">
              <strong>Butcher's Note:</strong> {selectedPrimal.butchers_note}
            </div>
          ) : (
            <span />
          )}

          <div className="cuts-results-header__filter">
            <select
              value={cookingMethodFilter}
              onChange={(event) => setCookingMethodFilter(event.target.value)}
              aria-label="Filter by cooking method"
            >
              <option value="">Filter by cooking method</option>
              {cookingMethods.map((method) => (
                <option key={method.id} value={method.id}>
                  {method.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </section>
  );
}
